import { FunctionComponent } from "react"
import SidebarContents from "./sidebar-contents"

const SidebarClosed: FunctionComponent = () => {
  return <SidebarContents isOpen={false} />
}

export default SidebarClosed
